export default function SupplierBankAccount() {

  return (
      <p>حساب های تأمین کننده</p>
  );
};